import { Trans } from 'react-i18next'
import { useLimitSwapPair, useLimitOrderUserConfig } from '~/state/dex/hooks'
import { useUSDValueSpread } from '../SpreadLabel'
import { TradeDirection } from '~/components/Exchange/types'
import NotificationBar from '~/components/NotificationBar'

const LowPriceOrderWarning: React.FC = () => {
  const [inputToken, outToken] = useLimitSwapPair()
  const { isInputRateDirection } = useLimitOrderUserConfig()
  const leftToken = isInputRateDirection ? inputToken : outToken
  const usdValueSpread = useUSDValueSpread(TradeDirection.Output)
  const percent = Math.abs(Number(usdValueSpread)).toString()

  const literal = isInputRateDirection
    ? 'lo_low_price_sell_warning_content'
    : 'lo_low_price_buy_warning_content'

  return (
    <NotificationBar
      level="risk"
      text={
        <Trans
          i18nKey={literal}
          values={{
            percent: percent,
            tokenSymbol: leftToken?.symbol,
          }}
          components={{
            bold: <span style={{ fontWeight: 700 }} />,
          }}
        />
      }
      showIcon={false}
      showLink={false}
      showClose={false}
      style={{ marginTop: '8px' }}
    />
  )
}

export default LowPriceOrderWarning
